/*
 * Support OAuth2 redirect from Plaid
 * 
 * good overview -> https://www.youtube.com/watch?v=E0GwNBFVGik
 */
import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment';

import withStyles from '@mui/styles/withStyles';
import LoadingSpinner from '../ui/LoadingSpinner';
import ACHFormIIPlaidOAuth from '../paymentsources/ACHFormIIPlaidOAuth';
import PaymentSourceDialog from '../ui/PaymentSourceDialog';
import ServerError from '../ui/ServerError';

import { Redirect } from 'react-router-dom';

const abEnvironment = new AbEnvironment();
const PlaidOAuth2RedirectQuery = graphql`
query PlaidOAuth2RedirectQuery($accountId: UUID!) {
  accountTByAccountId(accountId: $accountId) {
    accountStatus
    accountId
    accountName
    description
    contactFirstName
    contactLastName
    contactEmail
    contactPhone
    address1,
    address2,
    city
    state
    country
    postalCode
    dwollaCid
    stripeCid
    achActive 
    paymentSourceTsByAccountId(condition: {psStatus : 0}, orderBy: PS_ORDER_DESC) {
      nodes {
        psId
        psType
        psStatus
        psOrder
      }
    }
  }
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
  }
});

class PlaidOAuth2Redirect extends Component {

  state = {

    achOpen: true,

    forceFetch: 1
  }

  handleACHClose = () => {
    localStorage.removeItem('paymentReturn');
    localStorage.removeItem('plaid');
    let newForceFetch = this.state.forceFetch;
    newForceFetch++;
    this.setState({achOpen: false, forceFetch: newForceFetch});
  };

  setDwollaCidOnUInfo = (dwollaCid) => {
    let newForceFetch = this.state.forceFetch;
    newForceFetch++;
    this.setState({achOpen: false, forceFetch: newForceFetch});
  }
  
  render() {
    const { logError, isAuthenticated } = this.props.auth;
    const classes = this.props.classes;


    if (! isAuthenticated()) { 
      return ( <Redirect to='/home' /> );
    } else {
      let acctId = abEnvironment.getUserAttribute('a_id');

 

      return (
        <QueryRenderer
          environment={abEnvironment.getEnvironment()}
          query={PlaidOAuth2RedirectQuery}
          variables={{accountId: acctId, forceFetch: this.state.forceFetch}}
          render={({error, props})=> {
            if (error) {
              logError(error.message);
              return (
                <ServerError/>
              );
            } else if (props) {
    
    
              let uInfo = {
                accountId:   props.accountTByAccountId.accountId,
                accountName: props.accountTByAccountId.accountName,
                description: props.accountTByAccountId.description,
                firstName:   props.accountTByAccountId.contactFirstName,
                lastName:    props.accountTByAccountId.contactLastName,
                email:       props.accountTByAccountId.contactEmail,
                phone:       props.accountTByAccountId.contactPhone,
                address1:    props.accountTByAccountId.address1,
                address2:    props.accountTByAccountId.address2,
                city:        props.accountTByAccountId.city,
                state:       props.accountTByAccountId.state,
                country:     props.accountTByAccountId.country,
                postalCode:  props.accountTByAccountId.postalCode,
                dwollaCid:   props.accountTByAccountId.dwollaCid,
                stripeCid:   props.accountTByAccountId.stripeCid,
                achActive:   props.accountTByAccountId.achActive
              };

              let maxPSOrder = 0;
              let i = 0;
              for (i = 0; i < props.accountTByAccountId.paymentSourceTsByAccountId.nodes.length; i++) {
                let paymentSource = props.accountTByAccountId.paymentSourceTsByAccountId.nodes[i];
                if (paymentSource.psType === 0 || paymentSource.psType === 1) {
                  maxPSOrder = paymentSource.psOrder + 1;
                }
              }
    
              return (
    
                <PaymentSourceDialog
                  title="Add US Bank Account (ACH)"
                  open={this.state.achOpen}
                  onClose={this.handleACHClose} >
  
                  <ACHFormIIPlaidOAuth pcId={uInfo.dwollaCid} 
                          dAccountId={uInfo.accountId}
                          dAccountName={uInfo.accountName}
                          dFirstName={uInfo.firstName}
                          dLastName={uInfo.lastName}
                          dEmail={uInfo.email}
                          dPhone={uInfo.phone}
                          dAddress1={uInfo.address1}
                          dAddress2={uInfo.address2}
                          dCity={uInfo.city}
                          dState={uInfo.state}
                          dCountry={uInfo.country}
                          auth={this.props.auth}
                          porder={maxPSOrder}
                          setDwollaCidOnUInfo={this.setDwollaCidOnUInfo}
                          history={this.props.history}
                          onClose={this.handleACHClose}
                          />
                </PaymentSourceDialog>

              );
            

            }
            return <div><LoadingSpinner/></div>
          }
        }
        />
      );
    }

  }

}

export default withStyles(styleSheet)(PlaidOAuth2Redirect);